import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 15 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.017 8a.98.98 0 0 1-.695-.288L.288 1.678a.983.983 0 1 1 1.39-1.39l5.34 5.34 5.339-5.34a.983.983 0 1 1 1.39 1.39L7.711 7.712A.98.98 0 0 1 7.017 8" }, null, -1)
  ]))]))
}
export default { render: render }